var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SeparateSections',{attrs:{"titleSectionSeparate":"why_buy_title_section","subTitleSectionSeparate":"why_buy_description_section","idSelector":"scroll_helper_text_1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }